import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "../../utilities/Button";
import InputText from "../../components/FormElementos/InputText";
import { TextArea } from "../../components/FormElementos/TextArea";
import { useEffect, useState } from "react";
import { selectDTO } from "../../models/Home.model";
import { webApiContacto, webApiEscolaridad, webApiSexo,  } from "../../routes/endpoints";
import { SelectCombo } from "../../components/FormElementos/SelectCombo";
import Loading from "../../utilities/Loading";
import { ventana } from "../../utilities/Alertas";
import { ConvertirAFormDataContacto } from "../../models/FormularioContacto";
import {ErrorBoundary} from "react-error-boundary";
import ErrorMessageNotifications from "../../components/Errores/ErrorMessageNotifications";

export default function Formulario() {
    const [loading, setLoading] = useState(true)   
    const [escolaridad, setEscolaridad] =  useState<selectDTO[]>([]);
    const [sexo, setSexo] =  useState<selectDTO[]>([]);
    const [captch, setCaptch] = useState(false);

    useEffect(()=>{ 
        const requestSexo = axios.get(webApiSexo); 
        const requestEscolaridad = axios.get(webApiEscolaridad);
        axios.all([requestSexo, requestEscolaridad]).then(axios.spread((...responses) => {
             setSexo(responses[0].data)
             setEscolaridad(responses[1].data)
          })).catch(errors =>  console.warn(errors) )
          setLoading(false);
        },[]);
        const validate = Yup.object({
            nombre: Yup.string()
                .max(100, '*El número de caracteres no puede ser mayor a 100')
                .matches(/^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g, "Solo se permiten caracteres alfabéticos"),
            edad: Yup.number()
            .typeError('*No se aceptan caracteres')
            .required('*La edad es requerida')
            .positive("Solo acepta números positivos")
            .integer("Solo acepta números enteros")
            .max(150, '*El limite máximo de edad es de 150 años'),
            email: Yup.string()
                .max(100, '*El número de caracteres no puede ser mayor a 100')
                .email('*El formato de email no es correcto')
                .required('*El email es requerido'),
            escolaridad: Yup.string()
                .required('*La escolaridad es requerida'),
            sexo: Yup.string(),
            mensaj: Yup.string()
                .max(500, '*El número de caracteres no puede ser mayor a 500')
                .required('*El mensaje es requerido'),
          }) 
    function onChangeCaptcha(value:any) {
        setCaptch(value.length === 0?false:true)
    }  
    async function almacena(values:any){ 
            
        const formData = ConvertirAFormDataContacto(values);
        await axios({
          method: 'post',
          url:webApiContacto,
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {        
            if(response.data.error){
              ventana(response.data.mensaje, `Favor de revisar su registro nuevamente` , 'error');
            }else{          
              ventana(response.data.mensaje, `Favor de revisar el correo electrónico ${values.email}` , 'success');
            } 
          }).catch(err => console.warn(err));        
      }
    return( 
        <>    
         { loading ? <Loading /> : 
            <Formik 
                initialValues={{
                    nombre:'', edad:'', email:'', escolaridad:'', sexo:'', mensaj:''
                }} 
                validationSchema={validate}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    if(captch){    
                        almacena(values);     
                        resetForm()  
                        ventana('Mensaje recibido', `Mensaje de contacto recibido correctamente` , 'success');                      
                        setTimeout(() => { window.location.reload() }, 2000);
                      }else{          
                        ventana('reCAPTCHA', `Para continuar es necesario aceptar el reCAPTCHA` , 'info');
                        setSubmitting(false);  
                      }
            }}>     
        { ({ isSubmitting, handleChange}) => (

                <Form> 
                    <div className="col-12 text-center title_contact py-2">
                        <p className="mb-0">En un tribunal abierto, tu opinión cuenta. </p>                        
                        <p className="mb-0">Nos gustaría saber cuáles son tus sugerencias para mejorar nuestras publicaciones.</p>
                    </div>
                        <div className="row mt-3">
                            <div className="col-12"> 
                                <TextArea clase="text-area form-control input_contact_style" name="mensaj" placeholder="Escríbenos tu mensaje" rows={4}/>
                            </div>
                        </div>
                    <div className="row mx-0 my-3">
                        <div className="col-12 text-center text-contact">
                            <p className="mb-0 py-2">Si así lo decides, y para tener un mejor perfil de nuestros usuarios, déjanos saber los siguientes datos:</p>
                        </div>
                    </div>
                    <div className="col-12 px-0 mt-3">                                               
                        <div className="col-12 col-md-12">
                            <InputText label="" clase="form-control input_contact_style" name="nombre" type="text" placeholder="Nombre"/>
                        </div>                     
                        <div className="row mt-3">
                            <div className="col-12 col-md-3">
                                <InputText label="" clase="form-control input_contact_style" name="edad" type="text" placeholder="Edad"/>
                            </div>
                            <div className="col-12 col-md-3 mt-3 mt-md-0">
                                <InputText label="" clase="form-control input_contact_style" name="email" type="email" placeholder="Email"/>
                            </div>
                            <div className="col-12 col-md-3 mt-3 mt-md-0">        
                            <ErrorBoundary FallbackComponent={ErrorMessageNotifications}>                            
                                <SelectCombo label="" clase="form-select input_contact_style" name="escolaridad" data={escolaridad} handleChange={handleChange} textoSeleccion="Escolaridad"/>
                            </ErrorBoundary>
                            </div> 
                            <div className="col-12 col-md-3 mt-3 mt-md-0">
                            <ErrorBoundary FallbackComponent={ErrorMessageNotifications}> 
                                <SelectCombo label="" clase="form-select input_contact_style" name="sexo" data={sexo} handleChange={handleChange}  textoSeleccion="Género" />
                            </ErrorBoundary>                           
                            </div>
                        </div>
                        <div className="row mt-3">
                            <ReCAPTCHA
                            sitekey="6Lf7_mkgAAAAALK4AyAIsXTI6NEYZv3LDvVgm9HT"
                            onChange={onChangeCaptcha}
                            />                       
                        </div>                        
                        <Button type="submit" disabled={isSubmitting}>Enviar</Button>
                    </div>
                </Form>
                )}
            </Formik>
        }
        </>
    )
}